// extracted by mini-css-extract-plugin
module.exports = {"drinkingWindow":"drinkingWindow-module__drinkingWindow--2SXNO","text":"drinkingWindow-module__text--1GFiz"};